"use strict";

exports.__esModule = true;
var _DurationRangeSelector = require("./DurationRangeSelector");
Object.keys(_DurationRangeSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DurationRangeSelector[key]) return;
  exports[key] = _DurationRangeSelector[key];
});